// src/context/RoleLayout.js
import React, { useContext } from 'react';
import { AuthContext } from './AuthContext'; // same folder
import Layout from '../components/Layout';
import UserLayout from '../components/UserLayout';
import SupplierLayout from '../components/SupplierLayout';
import Unauthorized from '../components/Unauthorized';

export default function RoleLayout({ children }) {
  const { user, loading } = useContext(AuthContext);

  if (loading) return null;

  const role = (user?.role || '').toString().trim().toLowerCase();
  console.log('[RoleLayout]', { role, userPresent: !!user });

  if (role === 'admin')    return <Layout>{children}</Layout>;
  if (role === 'user')     return <UserLayout>{children}</UserLayout>;
  if (role === 'supplier') return <SupplierLayout>{children}</SupplierLayout>;

  return <Unauthorized />;
}
